import { useAppSelector } from './useAppSelector';

export function useSelectedAccountId(): string {
  return useAppSelector((state) => state.AuthState.selectedAccountId);
}
